import { useEffect } from "react";
import { useTour } from "@reactour/tour";
import { useLocation } from "react-router-dom";
import { PART_TO_PAGE } from "../../utils/PART_TO_PAGE";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { selectTutorialPage } from "../../redux/settings/selectors";
import { setSettingsPage } from "../../redux/settings/slice";

export default function TutorialStarter({ stepsArray }) {
  const { setIsOpen, setCurrentStep } = useTour();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const part = useSelector(selectTutorialPage);

  useEffect(() => {
    if (!stepsArray.length) return;

    if (state?.openTutorial) {
      const targetPage = PART_TO_PAGE[part];

      if (targetPage) {
        dispatch(setSettingsPage(targetPage));
      }
      setTimeout(() => {
        setCurrentStep(0);
        // setTimeout(() => setIsOpen(true), 1500);
      }, 0);
    }
  }, [stepsArray, state]);

  return null;
}
